import HubButton from 'components/HubButton'

export const App = ({ style }: { style?: string }) => {
  return <HubButton style={style} />
}

export default App
